module.exports = {
  DOMAIN: 'https://dev.galaxytherapeutics.com'
};
